export function getBooksyWrappedUrl (env) {
  let url = ''

  if (env.VUE_APP_BOOKSY_WRAPPED_URL) {
    // shortcut: force booksy wrapped url from env.
    url = env.VUE_APP_BOOKSY_WRAPPED_URL
  } else {
    url = window.location.origin.replace('://', '://booksy-wrapped.')
  }

  return url.replace(/\/+$/, '')
}

